export default __webpack_public_path__ + "static/media/Kedage.9c8ef30e.ttf";